import type { SegmentMeta } from "./types";

function formatSrtTimestamp(totalMs: number): string {
  const safeMs = Math.max(0, Math.round(totalMs));
  const hours = Math.floor(safeMs / 3_600_000);
  const minutes = Math.floor((safeMs % 3_600_000) / 60_000);
  const seconds = Math.floor((safeMs % 60_000) / 1_000);
  const milliseconds = safeMs % 1_000;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")},${String(milliseconds).padStart(3, "0")}`;
}

function formatLrcTimestamp(totalMs: number): string {
  const totalCentiseconds = Math.max(0, Math.round(totalMs / 10));
  const minutes = Math.floor(totalCentiseconds / 6_000);
  const seconds = Math.floor((totalCentiseconds % 6_000) / 100);
  const centiseconds = totalCentiseconds % 100;

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}.${String(centiseconds).padStart(2, "0")}`;
}

export function buildSrt(meta: SegmentMeta[]): string {
  let cursorMs = 0;

  return meta
    .map((item, displayIndex) => {
      const startMs = cursorMs;
      const endMs = startMs + item.durationMs;
      cursorMs = endMs;

      return `${displayIndex + 1}\n${formatSrtTimestamp(startMs)} --> ${formatSrtTimestamp(endMs)}\n${item.text}\n`;
    })
    .join("\n");
}

export function buildLrc(meta: SegmentMeta[]): string {
  let cursorMs = 0;

  const lines = meta.map((item) => {
    const line = `[${formatLrcTimestamp(cursorMs)}]${item.text}`;
    cursorMs += item.durationMs;
    return line;
  });

  return lines.length > 0 ? `${lines.join("\n")}\n` : "";
}
